<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>Cancel Subscription</v-card-title>
        <v-card-subtitle>We're sorry to see you go. Can you tell us why you're canceling?</v-card-subtitle>
        <v-card-text>
          <v-radio-group v-model="selectedReason">
            <v-radio label="This is too expensive" value="too_expensive"></v-radio>
            <v-radio label="This was created by accident" value="created_by_accident"></v-radio>
            <v-radio label="I want to receive the puzzles faster" value="want_faster_shipping"></v-radio>
            <v-radio label="I want to pick my own puzzle" value="want_to_pick_puzzle"></v-radio>
            <v-radio label="I don't have time to do this right now" value="no_time"></v-radio>
            <v-radio label="This was originally given to me as a gift" value="was_a_gift"></v-radio>
            <v-radio label="Other" value="other"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="goBack">Keep my subscription</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" :disabled="!selectedReason" @click="confirmCancel">Cancel subscription</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'cancel_subscription',
  props: ['subscription_id'],
  data: function() {
    return {
      selectedReason: null
    }
  },
  computed: {
    ...mapGetters({
      activeSubscription: 'getActiveSubscription',
    }),
  },
  methods: {
    goBack: function() {
      this.$router.push({ name: 'account', params: { subscription_id: this.subscription_id } });
    },
    confirmCancel: function() {
      if (this.selectedReason === 'want_faster_shipping') {
        this.$router.push({ name: 'shipping_retention_offer', params: { subscription_id: this.subscription_id } });
        return;
      }
      this.$router.push({ name: 'cancel_details', params: { subscription_id: this.subscription_id }, query: { reason: this.selectedReason } });
    }
  }
}
</script>
